<app-fullscreen-layout>
  <app-page-header>
    <app-page-title>
      <div class="flex gap-3 items-center">
        <div
          class="size-5 bg-admin rounded-full"
          [uiTooltip]="'cockpit.broker.adminOnlyTooltip' | transloco"
        ></div>
        {{ 'cockpit.parseRequests.brokerPage.title' | transloco }}
      </div>
    </app-page-title>
    <div class="flex gap-2 items-center" slot="end">
      <span class="flex-1 font-semibold">
        {{ 'cockpit.parseRequests.brokerPage.total' | transloco: { count: total() } }}
      </span>
      <div class="flex gap-2">
        <ui-select
          [formField]="tableForm.status"
          (change)="onChangeFilter()"
          [attr.aria-label]="'cockpit.parseRequests.brokerPage.filterStatus' | transloco"
        >
          <option value="ALL">
            {{ 'cockpit.parseRequests.brokerPage.filterAllStatus' | transloco }}
          </option>
          <option value="OPEN" [selected]="tableForm.status().value() === 'OPEN'">
            {{ 'cockpit.parseRequests.status.OPEN' | transloco }}
          </option>
          <option value="REQUESTED" [selected]="tableForm.status().value() === 'REQUESTED'">
            {{ 'cockpit.parseRequests.status.REQUESTED' | transloco }}
          </option>
          <option value="IN_PROGRESS" [selected]="tableForm.status().value() === 'IN_PROGRESS'">
            {{ 'cockpit.parseRequests.status.IN_PROGRESS' | transloco }}
          </option>
          <option value="DONE" [selected]="tableForm.status().value() === 'DONE'">
            {{ 'cockpit.parseRequests.status.DONE' | transloco }}
          </option>
        </ui-select>
        <ui-select
          [formField]="tableForm.page"
          (change)="onChangeFilter()"
          [attr.aria-label]="'cockpit.parseRequests.brokerPage.filterPage' | transloco"
        >
          @for (option of pageOptions(); track option) {
            <option [value]="option" [selected]="tableForm.page().value() === option">
              {{
                'cockpit.parseRequests.brokerPage.filterPageOption' | transloco: { number: option }
              }}
            </option>
          } @empty {
            <option>
              {{
                'cockpit.parseRequests.brokerPage.filterPageOption'
                  | transloco: { number: tableForm.page().value() }
              }}
            </option>
          }
        </ui-select>
        <ui-select
          [formField]="tableForm.limit"
          (change)="onChangeFilter()"
          [attr.aria-label]="'cockpit.parseRequests.brokerPage.filterLimit' | transloco"
        >
          <option value="20" [selected]="tableForm.limit().value() === '20'">
            {{ 'cockpit.parseRequests.brokerPage.filterLimitOption' | transloco: { count: 20 } }}
          </option>
          <option value="50" [selected]="tableForm.limit().value() === '50'">
            {{ 'cockpit.parseRequests.brokerPage.filterLimitOption' | transloco: { count: 50 } }}
          </option>
          <option value="100" [selected]="tableForm.limit().value() === '100'">
            {{ 'cockpit.parseRequests.brokerPage.filterLimitOption' | transloco: { count: 100 } }}
          </option>
        </ui-select>
      </div>
    </div>
  </app-page-header>

  @if (parseRequests.isLoading()) {
    <div class="flex justify-center items-center py-25">
      <ui-loading-spinner size="100" class="size-5" />
    </div>
  } @else if (parseRequests.error()) {
    <app-error-page [error]="parseRequests.error()" (clickBack)="router.navigate(['/admin'])" />
  } @else {
    <table
      class="relative min-w-full table-fixed divide-y divide-outline dark:divide-outline-darkmode"
    >
      <thead>
        <tr>
          <th class="px-3 py-3.5 text-start text-sm whitespace-nowrap font-semibold">
            {{ 'cockpit.parseRequests.brokerPage.tableHeaderOrganization' | transloco }}
          </th>
          <th class="px-3 py-3.5 text-start text-sm whitespace-nowrap font-semibold">
            {{ 'cockpit.parseRequests.brokerPage.tableHeaderStatus' | transloco }}
          </th>
          <th class="px-3 py-3.5 text-start text-sm whitespace-nowrap font-semibold">
            {{ 'cockpit.parseRequests.brokerPage.tableHeaderCreatedBy' | transloco }}
          </th>
          <th class="px-3 py-3.5 text-start text-sm whitespace-nowrap font-semibold">
            {{ 'cockpit.parseRequests.brokerPage.tableHeaderCreatedAt' | transloco }}
          </th>
          <th class="max-w-[53px]"></th>
        </tr>
      </thead>
      <tbody
        class="divide-y divide-outline bg-surface dark:divide-outline-darkmode dark:bg-surface-darkmode"
      >
        @for (pr of value()?.items; track $index) {
          <tr>
            <td class="px-3 py-3.5 text-sm whitespace-nowrap">
              @if (organizationsLoading()) {
                <ui-skeleton class="w-32 h-5 block rounded-full" />
              } @else if (organizationsLoadingError()) {
                {{ pr.organizationId }}
              } @else {
                {{ pr.organizationId | organizationName }}
              }
            </td>
            <td class="px-3 py-3.5 text-sm whitespace-nowrap">
              <ui-badge>
                {{ 'cockpit.parseRequests.status.' + pr.status | transloco }}
              </ui-badge>
            </td>
            <td class="px-3 py-3.5 text-sm whitespace-nowrap">
              {{ pr.metadata.createdBy?.email || '-' }}
            </td>
            <td class="px-3 py-3.5 text-sm whitespace-nowrap">
              {{ pr.metadata.createdAt | date: 'dd.MM.yy HH:mm:ss' }}
            </td>
            <td class="max-w-[53px]">
              <a [routerLink]="['/organizations', pr.organizationId, 'parse-requests', pr.id]">
                <ui-button mode="outlined" [iconOnly]="true" size="small">
                  <ng-icon name="heroArrowRight" size="20" class="!block" />
                </ui-button>
              </a>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</app-fullscreen-layout>
<app-feedback-fab *appTechnicalMonitoringEnabled class="fixed bottom-5 right-5" />
